require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bics-statement-on-the-resignation-of-world-bank-president.json") })
        }
      }, "path---en-us-update-bics-statement-on-the-resignation-of-world-bank-president");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bics-statement-on-the-resignation-of-world-bank-president!./.cache/json/en-us-update-bics-statement-on-the-resignation-of-world-bank-president.json
// module id = 632
// module chunks = 231608221292675